import { createSlice } from "@reduxjs/toolkit"
import { objectSelector as _get } from '../../utils';

const initialState = {
  basket: {},
  errors: [],
  pending: true,
}

const basketSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    setBasket(state, { payload }) {
      state.basket = _get(payload, 'basket', initialState.basket);
      state.pending = false;
    },
    errorBasket(state, { payload }) {
      state.errors = state.errors.filter(item => item.pk !== payload.pk)
      state.errors.push(payload);
      state.pending = false;
    },
    clearErrorBasket(state, { payload }) {
      const { pk } = payload
      if (!pk)
        state.errors = []
      else
        state.errors = state.errors.filter(item => item.pk !== pk)
    },
    pending(state) {
      state.pending = true;
    }
  }
});

export const {
  setBasket,
  errorBasket,
  clearErrorBasket,
  pending,
} = basketSlice.actions;

export const actions = basketSlice.actions;

export default basketSlice.reducer;